var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#134A81",
    d: "M21.107 1.034l-9.18 7.348c-.349.292-.785.45-1.243.45-.458 0-.894-.158-1.243-.45L.261 1.034A2.164 2.164 0 000 2.022v9.956C0 13.1.894 14 1.962 14h17.444c1.09 0 1.962-.921 1.962-2.022V2.022c0-.36-.087-.674-.261-.988zM10.684 7.775a.896.896 0 00.61-.224L20.388.27a1.842 1.842 0 00-.981-.27H1.962c-.348 0-.697.09-.98.27l9.092 7.28a.892.892 0 00.61.225z"
  })));
}
export default SvgEmail;